import { CabinetManagerRoleType } from '../manager';

export type AccessRecoveryFastTrackServer = {
  access_recovery?: {
    recovery_token: string;
  };
};

export type AccessRecoveryCabinetServer = {
  cabinet_id: string;
  name: string;
  role: CabinetManagerRoleType;
};

export type AccessRecoveryVerifyLinkServer = {
  recovery_token: string;
  cabinets: AccessRecoveryCabinetServer[];
};

export enum AccessRecoveryError {
  LINK_INVALID = 'recovery_link_invalid',
  TOKEN_EXPIRED = 'recovery_token_expired'
}

export enum AccessRecoveryOAuthError {
  PENDING_EXPIRED = 'pending_expired',
  OAUTH_ACCOUNT_ALREADY_LINKED = 'oauth_account_already_linked'
}
